import { Spinner } from "../../../../atoms";

const ListProjecteApiLoading = () => {
  return (
    <Spinner></Spinner>
  );
};

export default ListProjecteApiLoading;
